/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ProfileProjectStatusUpdates_viewer$ref = any;
type SettingsProfileSubNav_viewer$ref = any;
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileProjectStatusUpdatesPage_viewer$ref: FragmentReference;
declare export opaque type ProfileProjectStatusUpdatesPage_viewer$fragmentType: ProfileProjectStatusUpdatesPage_viewer$ref;
export type ProfileProjectStatusUpdatesPage_viewer = {|
  +projectOwner: ?boolean,
  +disableNotifications: ?boolean,
  +company: ?{|
    +forecastDemo: ?boolean,
    +tier: ?TierType,
  |},
  +$fragmentRefs: ProfileProjectStatusUpdates_viewer$ref & SettingsProfileSubNav_viewer$ref,
  +$refType: ProfileProjectStatusUpdatesPage_viewer$ref,
|};
export type ProfileProjectStatusUpdatesPage_viewer$data = ProfileProjectStatusUpdatesPage_viewer;
export type ProfileProjectStatusUpdatesPage_viewer$key = {
  +$data?: ProfileProjectStatusUpdatesPage_viewer$data,
  +$fragmentRefs: ProfileProjectStatusUpdatesPage_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileProjectStatusUpdatesPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastDemo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileProjectStatusUpdates_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = 'c102696a5d8696a93f54e686974b0d9c';

module.exports = node;
